module.exports = __webpack_public_path__ + "media/images/flip-camera-btn-80c2109ceac8dbefa13dadeef1682dd2ec5924ec168e98f74d716ee9a5fc6e58.svg";